import * as universal from "../../../../src/routes/(app)/+page.ts";
export { universal };
export { default as component } from "../../../../src/routes/(app)/+page.svelte";